export default __webpack_public_path__ + "static/char-s-33-zh-Hant-ca309757f9a51600626827f51ccb7068.png";